import { useEffect } from 'react';

const useScrollDisable = (elem) => {
    useEffect(() => {
        if (elem) {
            document.body.classList.add('overflow_hide');
        } else {
            document.body.classList.remove('overflow_hide');
        }
        return () => {
            document.body.classList.remove('overflow_hide');
        };
    }, [elem]); 

};

export default useScrollDisable;
